import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { breaks: () => import('./BreaksPage.vue') },
} satisfies FeatureRoutes
